export enum AssignedProductTypeException {
  CODE_NO_ASSIGNED_AND_ADDITIONAL_PRODUCT_TYPES = 1,
  CODE_INVALID_ASSIGNED_PRODUCT_TYPE = 2,
  CODE_PRODUCT_TYPE_CANNOT_BE_ASSIGNED = 3,
  CODE_DEFAULT_PRODUCT_TYPE_CANNOT_BE_ASSIGNED = 4,
}
